import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";
import axios from "axios";
import store from "@/store";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'TableInvoicesAll',
  setup(__props) {

const messageList = ref({ mesaje: [], serial: "", cui: "", titlu: "" });

onMounted(() => {
  getInvoices();
});

store.watch(
  (state) => state.invoicesUploaded,
  (uploaded) => {
    if (uploaded) {
      getInvoices();
      store.commit("setInvoicessUploaded", false);
    }
  }
);
function getInvoices() {
  axios
    .get("api/v1/anafgetlist")
    .then((response) => {
      response.data.mesaje.forEach(
        (mesaje: { data_creare: string; date_formated: string }) => {
          mesaje.date_formated = formatDate(mesaje.data_creare);
        }
      );
      messageList.value = response.data;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function downloadInvoice(id: string) {
  axios
    .get(`api/v1/anafgetbyreference/${id}`, {
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${id}.zip`);
      document.body.appendChild(link);
      link.click();
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function formatDate(date: string) {
  return dayjs(date, "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm");
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      label: "Refresh",
      icon: "pi pi-refresh",
      class: "p-button-success p-button-rounded mx-3",
      onClick: getInvoices
    }),
    _createVNode(_component_DataTable, {
      value: messageList.value.mesaje,
      scrollHeight: `${_unref(store).state.win.h - 140}px`,
      style: _normalizeStyle(`height: ${_unref(store).state.win.h - 140}px; width: ${
      _unref(store).state.win.w - 230
    }px`),
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "detalii",
          header: "Detail",
          sortable: ""
        }),
        _createVNode(_component_Column, {
          field: "date_formated",
          header: "Created",
          sortable: "",
          sortField: "data_creare"
        }),
        _createVNode(_component_Column, { header: "Download" }, {
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              icon: "pi pi-download",
              class: "p-button-rounded p-button-success",
              style: {"width":"30px","height":"30px"},
              onClick: ($event: any) => (downloadInvoice(slotProps.data.id))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "scrollHeight", "style"])
  ], 64))
}
}

})